import { v4 } from "uuid";
import { ColorScheme, QueryLanguage, UiState } from "#store/ui/uiTypes";
import { DatasourceEnum } from "#services/pilotService/types";

const key = "jazzy-bear-preferences";

const write = (state: UiState) => {
    localStorage.setItem(key, JSON.stringify(state));
};

const initialState: UiState = {
    savedSessions: [],
    selectedDatasource: {
        name: DatasourceEnum.cordis,
        label: "default - cordis - sql",
        queryLanguage: "sql",
    },
    selectedQueryLanguage: QueryLanguage.SQL,
    theme: ColorScheme.OS,
    appDrawer: {
        visible: false,
    },
    rid: v4(),
    maxInterpretationsLimit: 3,
    rowsPerTableLimit: 100,
    activeInterpretations: [],
    favoriteColumns: [],
    doiWeights: [1 / 4, 1 / 4, 1 / 4, 1 / 4],
    query: "",
    history: [],
};

const read = (): UiState => {
    const lSState = localStorage.getItem(key);
    if (typeof lSState === "string") {
        // poor mans migration:
        const parsed = JSON.parse(lSState);
        if (typeof parsed === "object") {
            return {
                ...initialState,
                ...parsed,
            };
        }
    }
    return initialState;
};

export { read, write };
